import StatusBadge from "./StatusBadge";

export default function ClientNotesTab({ tasks, activityFeed }) {
  return (
    <section className="grid gap-4 lg:grid-cols-2">
      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-sm font-semibold text-slate-900">Open taken</h3>
          <button type="button" className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50">
            + Taak toevoegen
          </button>
        </div>

        <ul className="space-y-3">
          {tasks.map((task) => (
            <li key={task.id} className="rounded-lg border border-slate-200 p-3">
              <div className="mb-2 flex items-center justify-between gap-2">
                <p className="text-sm font-medium text-slate-800">{task.titel}</p>
                <StatusBadge value={task.prioriteit} />
              </div>
              <div className="flex items-center justify-between text-xs text-slate-500">
                <span>Status: {task.status}</span>
                <span>Deadline: {task.deadline}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
        <h3 className="mb-4 text-sm font-semibold text-slate-900">Interne notities en recente opmerkingen</h3>
        <div className="space-y-3">
          {activityFeed.map((item) => (
            <article key={item.id} className="rounded-lg border border-slate-100 bg-slate-50 p-3">
              <p className="text-xs text-slate-500">{item.datumTijd} • {item.actor}</p>
              <p className="mt-1 text-sm text-slate-700">{item.actie}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
